import "./dropdown.css";
import React, { useState, useEffect } from "react";
import Collegue from "./collegue ";
import Keyboard from "./Keyboard";
import Navbar from "./Navbar";
import Journal from "./Journal";
import Contacts from "./contacts";
// import Push from 'push.js'
const poste = localStorage.getItem("poste");
function Dropdown({
  callClick,
  callClickVideo,
  navbar,
  token,
  echecCurrentAppel,
  cancelEchecAppel,
  tab,
}) {
  const [tap, setTap] = useState("phone");

  useEffect(() => {
    //  var win = window.open(
    //                             "aa.html",
    //                             "DescriptiveWindowName",
    //                             "width=420,height=230,resizable,scrollbars=yes,status=1"
    //                             );
  }, []);

  return (
    <div className="dropdown dark:bg-gray-800" style={{ borderRadius: "30px" }}>
      <div
        className=""
        style={{
          width: "100%",
          height: "27px",
          borderRadius: "30px 30px 0px 0px",
        }}
      >
        <div
          style={{
            marginLeft: navbar ? "20px" : "70px",
            height: "100%",
            paddingTop: "6px",
            fontWeight: "500",
            color: "rgba(0, 0, 0, 0.85)",
          }}
        >
          {tap === "logs"
            ? "Journal d'appel"
            : tap === "user"
            ? "Collègues"
            : tap === "contacts"
            ? "Contacts"
            : tap === "voicecall"
            ? "Boite vocale"
            : ""}
        </div>
      </div>
      {tap === "phone" ? (
        <Keyboard
          callClick={callClick}
          callClickVideo={callClickVideo}
          navbar={navbar}
          echecCurrentAppel={echecCurrentAppel}
          cancelEchecAppel={cancelEchecAppel}
          tab={tab}
        />
      ) : tap === "logs" ? (
        <div>
          <Journal
            navbar={navbar}
            token={token}
            poste={poste}
            callClick={callClick}
            tabHeight={360}
          />
        </div>
      ) : tap === "user" ? (
        <div>
          <Collegue
            callClick={callClick}
            callClickVideo={callClickVideo}
            navbar={navbar}
            token={token}
            poste={poste}
            tabHeight={360}
          />
        </div>
      ) : tap === "contacts" ? (
        <div>
          <Contacts navbar={navbar} callClick={callClick} tabHeight={335} />
        </div>
      ) : null}

      {/* <Navbar setTap={setTap} tap={tap} navbar={navbar} show={true} /> */}
    </div>
  );
}

export default Dropdown;
